var map = {
	"./favicon": 12,
	"./favicon.svg": 12,
	"./favicon_180": 13,
	"./favicon_180.png": 13,
	"./favicon_192": 14,
	"./favicon_192.png": 14,
	"./favicon_512": 15,
	"./favicon_512.png": 15
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 58;